import { ErrorMessage, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '../../CustomControls/Button';
import { Add, Save } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { FormErrorMessage } from '../../Validations/FormValidationErrors';
import { SnomedPicker } from '../../CustomControls/SnomedPicker';
import { snomedExpressions } from '../../../variables/Enums';
import { groupValidations } from './GroupValidations';
import { Col, Grid, Row } from 'react-bootstrap';
import { ProtocolPicker } from '../../CustomControls/ProtocolPicker';

const CreateGroup = ({ onCreate}) => {
    const { t } = useTranslation();

    const [isShowing, setIsShowing] = useState(false);

    const handleCreate = (group, actions) => {
        if (!group.name) {
            actions.setSubmitting(false);
            return;
        }
        if (onCreate) {
            //setIsShowing(false);
            onCreate(group);
            actions.setSubmitting(false);
        }
    };

    const handleOnClose = () => {
        setIsShowing(false);
    }

    return (
        <>
            <button type="button" className="btn btn-primary" onClick={() => { setIsShowing(true) }} ><Add />{t("buttons.add")}</button >
            <ModalData
                isShowing={isShowing}
                hide={handleOnClose}
                title="Nuevo Grupo"
                size="medium"
                className=""
            >
                <Formik
                    onSubmit={handleCreate}
                    validationSchema={groupValidations}
                >
                    {props => (
                        <form onSubmit={props.handleSubmit}>
                            <Col >
                                <div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.name")}</ControlLabel>
                                        <FormControl type="text" name='name' value={props.values?.name} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="name" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.description")}</ControlLabel>
                                        <FormControl componentClass="textarea" name='description' value={props.values?.description} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="description" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.patientLimit")}</ControlLabel>
                                        <FormControl type="number" name='patientLimit' value={props.values?.patientLimit} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="patientLimit" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.groupPatientLimit")}</ControlLabel>
                                        <FormControl type="number" name='groupPatientLimit' value={props.values?.groupPatientLimit} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="groupPatientLimit" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.specialties")}</ControlLabel>
                                        <div>
                                            <SnomedPicker
                                                defaultSelected={props.values.specialties ? [props.values.specialties] : []}
                                                id="specialties"
                                                value={props.values.specialties}
                                                name="specialties"
                                                placeholder={t("commons.search")}
                                                onChange={props.setFieldValue}
                                                onBlur={props.setFieldTouched}
                                                conceptId={snomedExpressions.Especialidades}
                                                multiple={true}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.groupProtocols")}</ControlLabel>
                                        <ProtocolPicker
                                            id="protocol"
                                            name="protocolIds"
                                            multiple={true}
                                            placeholder={t("filters.protocol")}
                                            // Usamos props.setFieldValue para actualizar el estado
                                            onChange={(name, selectedOptions) => {
                                                // Mapeamos el array de objetos a un array de IDs
                                                const selectedIds = selectedOptions.map(option => option.id);
                                                props.setFieldValue(name, selectedIds);
                                            }}
                                            value={props.values.protocolIds}
                                        />
                                    </div>
                                    <hr />
                                    <Button type="submit" className="btn btn-success btn-primary btn-right" disabled={props.isSubmitting}><Save />{t("buttons.save")}</Button>
                                    <Button type="button" className="btn " onClick={handleOnClose} >{t("buttons.cancel")}</Button>
                                </div>
                            </Col>
                        </form>
                    )}
                </Formik>
            </ModalData>
        </>
    );
};

export default CreateGroup;